var React = require('react');

function Four (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"four"),React.createElement("path",{"d":"M45.68.5C78.15.5,90.87,29.36,90.87,64.92s-12.72,64.43-45.19,64.43S.5,100.49.5,64.92,13.21.5,45.68.5ZM26.61,85,52.55,24A11.93,11.93,0,0,0,45.68,22C32.11,22,24.55,41.39,24.55,64.92A91.86,91.86,0,0,0,26.61,85Zm38-40.38L38.64,105.81a12.5,12.5,0,0,0,7,2.07c13.57,0,21.13-19.42,21.13-43A83.16,83.16,0,0,0,64.58,44.65Z","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M147.38,126.77V102.55H99.45v-24L150.13,3.08H174V78.5h15v24H174v24.22Zm0-48.27V44.31L125.22,78.5Z","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","key":2})]);
}

Four.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 189.46 129.85"};

module.exports = Four;

Four.default = Four;
